import { render, staticRenderFns } from "./GiveawayTile.vue?vue&type=template&id=1c19b249&lang=pug&"
import script from "./GiveawayTile.vue?vue&type=script&lang=js&"
export * from "./GiveawayTile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports